import { theme } from "../commons/theme";
export const foreColor = (mode) => {
  return {
    color:
      mode === "lite"
        ? theme.palette.liteColor.foreColor.main
        : theme.palette.darkColor.foreColor.main,
  };
};

export const foreColorDisabled = (mode) => {
  return {
    color:
      mode === "lite"
        ? theme.palette.liteColor.backColor.disabled
        : theme.palette.darkColor.backColor.disabled,
  };
};

export const foreColorLoginDesc = (mode) => {
  return {
    color:
      mode === "lite"
        ? theme.palette.darkColor.backColor.main
        : theme.palette.liteColor.backColor.main,
  };
};
export const backgroundColorLoginDesc = (mode) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.light
        : theme.palette.darkColor.backColor.medium,
  };
};
export const foreColorOnMouseOver = (mode) => {
  return {
    color:
      mode === "lite"
        ? theme.palette.liteColor.foreColor.hover
        : theme.palette.darkColor.foreColor.hover,
  };
};

export const backgroundColor = (mode) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.medium
        : theme.palette.darkColor.backColor.dark,
  };
};
export const backgroundColorDnd = (mode) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.medium
        : theme.palette.darkColor.backColor.main,
  };
};
export const backgroundColorDrafts = (mode) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.medium
        : theme.palette.darkColor.backColor.light,
  };
};
export const foreColorChecked = (mode, isChecked) => {
  if (isChecked) {
    return {
      color:
        mode === "lite"
          ? theme.palette.liteColor.foreColor.main
          : theme.palette.darkColor.foreColor.main,
    };
  } else {
    return {
      color:
        mode === "lite"
          ? theme.palette.liteColor.backColor.dark
          : theme.palette.darkColor.backColor.light,
    };
  }
};
export const foreColorPagination = (mode) => {
  return {
    color:
      mode === "lite"
        ? theme.palette.liteColor.foreColor.dark
        : theme.palette.darkColor.foreColor.dark,
  };
};

export const foreColorPaginationError = (mode) => {
  return {
    color:
      mode === "lite"
        ? theme.palette.liteColor.foreColor.error
        : theme.palette.darkColor.foreColor.error,
  };
};

export const foreColorCode = (mode) => {
  if (mode === "lite") {
    return theme.palette.liteColor.foreColor.main;
  } else {
    return theme.palette.darkColor.foreColor.main;
  }
};
export const foreColorCodePagination = (mode) => {
  if (mode === "lite") {
    return theme.palette.liteColor.foreColor.dark;
  } else {
    return theme.palette.darkColor.foreColor.dark;
  }
};
export const foreColorCodeLite = (mode) => {
  if (mode === "lite") {
    return theme.palette.liteColor.foreColor.dark;
  } else {
    return theme.palette.darkColor.foreColor.light;
  }
};
export const foreColorCodeDisabled = (mode) => {
  if (mode === "lite") {
    return theme.palette.liteColor.backColor.disabled;
  } else {
    return theme.palette.darkColor.backColor.disabled;
  }
};
export const backGroundColorCode = (mode) => {
  if (mode === "lite") {
    return theme.palette.liteColor.backColor.medium;
  } else {
    return theme.palette.darkColor.backColor.dark;
  }
};
export const foreColorCodeOnMouseOver = (mode) => {
  if (mode === "lite") {
    return theme.palette.liteColor.foreColor.light;
  } else {
    return theme.palette.darkColor.foreColor.light;
  }
};
export const backColorModal = (mode) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.light
        : theme.palette.darkColor.backColor.light,
  };
};
export const backColorTableHeader = (mode) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.darkColor.backColor.tableHeader
        : theme.palette.darkColor.backColor.tableHeader,
  };
};
export const backColorTableRowAdd = (mode) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.tableRowAdd
        : theme.palette.darkColor.backColor.tableRowAdd,
  };
};
export const backColorTableRowEven = (mode) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.tableRowEven
        : theme.palette.darkColor.backColor.tableRowEven,
  };
};
